module.exports = __webpack_public_path__ + "img/personal-web03.24c492fe.png";